const paginationArea = document.querySelector('.p-achievement-pagination');

if(paginationArea != null){
  const paginationAreaInner = document.querySelector('.p-achievement-pagination__inner').childNodes;
  if(paginationAreaInner.length > 2 ) {
    const achievementContents = document.querySelectorAll('.p-achievement-contents');
    const pageNumbers = [...document.querySelectorAll('.p-achievement-pagination__inner .pagination li .page-numbers')];
    
    if(achievementContents.length % 2 === 0){
      paginationArea.style.backgroundColor = '#fff';
      pageNumbers.forEach((num) => {
        num.style.backgroundColor = '#F1F1F1';
        num.addEventListener('mouseover', () => {
          num.style.backgroundColor = '#d6d4cd';
        })
        num.addEventListener('mouseleave', () => {
          num.style.backgroundColor = '#F1F1F1';
        })
      })
    }
  
    const prevButton = document.querySelector('.prev.page-numbers');
    const nextButton = document.querySelector('.next.page-numbers');
  
    if(prevButton == null) {
      nextButton.classList.add('is-center');
    }
    if(nextButton == null) {
      prevButton.classList.add('is-center');
    }
  } else if (paginationAreaInner.length <= 1) {
    paginationArea.style.display = 'none';
  }
  
}
